
import {getToken, setToken, removeToken} from '../utils/auth'
import {login,getInfo} from "../api/loginred";

const user = {
  state: {
    token: getToken(),
    name: '',
    avatar: '',
    phone: '',
    userInfo:{},
    kfPhone:'',
    withdrawObj:{},
    user1:{
      real_name:''
    }
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_game_num: (state, game_num) => {
      state.game_num = game_num
    },
    SET_KF_PHONE:(state,phone)=>{
      state.kfPhone=phone;
    },
    SET_WITHDRAW_MIN:(state,obj)=>{
      state.withdrawObj=obj;
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_PHONE: (state, roles) => {
      state.phone = roles
    },
    SET_USERINFO: (state,userinfo) => {
      state.userInfo=userinfo;
    },
    SET_tradepwd: (state,alipay) => {
      state.alipay=alipay;
    },
    SET_User: (state,uesr) => {
      state.uesr=uesr;
    }
  },

  actions: {
    // 登录
    Login({commit}, userInfo) {
      var that = this
      return new Promise((resolve, reject) => {
        login(userInfo).then(response => {
          const data = response;
          setToken(data.token);
          commit('SET_TOKEN', data.token)
          commit('SET_User', data.user)
          localStorage.setItem("tokenWeb", data.token);
          localStorage.setItem('user', JSON.stringify(data.user))
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo({commit, state}) {
      return new Promise((resolve, reject) => {
        getInfo().then(response => {
          console.log("获取用户信息中....");
          let userInfo = response.result;
          commit('SET_User', userInfo)
          // this.$store.state.zhenshi = userInfo
          localStorage.setItem('user', JSON.stringify(userInfo))
          setToken(localStorage.getItem('tokenWeb'));
          /*
           commit('SET_PHONE', userInfo.userphone);
           commit('SET_NAME', userInfo.loginname);
           commit('SET_game_num', response.game_num);
           commit('SET_KF_PHONE', response.kf_phone);
           commit('SET_tradepwd', userInfo.alipay);
           commit('SET_WITHDRAW_MIN', {
             withdrawMin:response.withdraw_min,
             withdrawFee:response.withdraw_fee,
             yongjin_min:response.yongjin_min,
             yongjin_lever:response.yongjin_lever
           });
           commit('SET_AVATAR', userInfo.userphoto);
           commit('SET_USERINFO',userInfo);*/

          resolve(response)
        }).catch(error => {
          console.log("error=>获取用户信息失败")
          reject(error)
        })
      })
    },

    // 登出
    LogOut({commit, state}) {
      return new Promise((resolve, reject) => {

        commit('SET_PHONE', '');
        commit('SET_NAME', '');
        commit('SET_AVATAR', '');
        commit('SET_USERINFO','');
        commit('SET_game_num','');
        commit('SET_tradepwd','');
        removeToken();
        localStorage.clear();
        resolve();
      })
    },

    // 前端 登出
    FedLogOut({commit}) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/user.js